export default "__VITE_PUBLIC_ASSET__10c134c6__"